/**
 * Types and schema for the Dexie DB (file thumbnails blob cache).
 */

/** Entry stored in IndexedDB for a file thumbnail blob (decrypted JPEG). */
export interface FileThumbnailBlobEntry {
  fileId: number;
  blob: Blob;
  savedAt: number;
}

/** Dexie schema string for the fileThumbnails table: primary key fileId, index savedAt for eviction. */
export const FILE_THUMBNAILS_STORE_SCHEMA = 'fileId, savedAt';

/** TTL for file thumbnail blobs: 24 hours. */
export const FILE_THUMBNAIL_TTL_MS = 24 * 60 * 60 * 1000;

/** Maximum number of file thumbnail blob entries to keep; eviction removes oldest by savedAt. */
export const FILE_THUMBNAIL_MAX_COUNT = 500;

/** Dexie schema for uploadSessions: primary key sessionId, indexes userId and expiresAt. */
export const UPLOAD_SESSIONS_STORE_SCHEMA = 'sessionId, userId, expiresAt';

/** Dexie schema for uploadQueueItems: primary key itemId, index sessionId. */
export const UPLOAD_QUEUE_ITEMS_STORE_SCHEMA = 'itemId, sessionId';

/** Dexie schema for uploadQueueBlobs: primary key itemId, index sessionId. */
export const UPLOAD_QUEUE_BLOBS_STORE_SCHEMA = 'itemId, sessionId';

/** TTL for persisted upload sessions: 24 hours. */
export const UPLOAD_SESSION_TTL_MS = 24 * 60 * 60 * 1000;

/** ponytail: cap total blob bytes per session; over cap → skip IDB persist, in-memory only. */
export const UPLOAD_BLOB_MAX_TOTAL_BYTES = 500 * 1024 * 1024;

/** Feature flag: set false to disable upload queue persistence without removing code. */
export const UPLOAD_QUEUE_PERSISTENCE_ENABLED = true;

export interface UploadSessionEntry {
  sessionId: string;
  userId: number;
  isQuickShare: boolean;
  quickShareForm: string;
  targetFolderUid: number | null;
  createdAt: number;
  updatedAt: number;
  expiresAt: number;
}

export interface UploadQueueItemEntry {
  itemId: string;
  sessionId: string;
  metadata: string;
}

export interface UploadQueueBlobEntry {
  itemId: string;
  sessionId: string;
  blob: Blob;
}
